export type { TextProps, TextRootNodeComponent, TextVariant } from './text'
export { default } from './text'
